// removed by extract-text-webpack-plugin
module.exports = {"results-wrapper":"SearchResultsTab-module-results-wrapper-WlFzv","resultsWrapper":"SearchResultsTab-module-results-wrapper-WlFzv","white-bg":"SearchResultsTab-module-white-bg-ggKtu","whiteBg":"SearchResultsTab-module-white-bg-ggKtu","results-container":"SearchResultsTab-module-results-container-2Oa77","resultsContainer":"SearchResultsTab-module-results-container-2Oa77"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchResultsTab/SearchResultsTab.module.scss
// module id = 940
// module chunks = 0